import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./motion";

export default function BlogIndex({ blogs = [] }) {
  return (
    <section id="writing" data-testid="writing-section" className="relative mx-auto max-w-[1400px] px-6 md:px-10 py-28 md:py-36">
      <Reveal>
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <span className="font-mono text-xs uppercase tracking-[0.28em] text-[#7a7a7a]">/ 02 — Writing</span>
            <h2 className="font-serif text-5xl md:text-7xl tracking-tighter text-[#FAFAFA] mt-5 leading-[0.88]">
              Words &amp; <span className="italic font-light text-[#bdbdbd]">essays</span>
            </h2>
          </div>
          <p className="text-[#8f8f8f] max-w-sm md:text-right">
            Long-form pieces on travel, love, cities and the people who stay. Every word, as written.
          </p>
        </div>
      </Reveal>

      <div className="border-t border-[#1c1c1c]">
        {blogs.map((b, i) => (
          <Reveal key={b.slug} delay={i * 0.04}>
            <Link
              to={`/blog/${b.slug}`}
              data-testid={`blog-card-${b.slug}`}
              className="group grid grid-cols-1 md:grid-cols-12 gap-6 items-center py-8 border-b border-[#1c1c1c] hover:bg-[#0b0b0b] transition-colors duration-500 px-2 -mx-2"
            >
              <div className="md:col-span-1 font-mono text-xs text-[#5a5a5a]">
                {String(i + 1).padStart(2, "0")}
              </div>

              <div className="md:col-span-2 overflow-hidden aspect-[4/3] bg-[#0d0d0d] border border-[#1c1c1c]">
                <motion.img
                  src={b.cover}
                  alt={b.title}
                  loading="lazy"
                  className="h-full w-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
                />
              </div>

              <div className="md:col-span-7">
                <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#7a7a7a] mb-2">
                  {b.category} · {b.read_time}
                </div>
                <h3 className="font-serif text-3xl md:text-4xl tracking-tight text-[#FAFAFA] group-hover:italic transition-all duration-300 leading-tight">
                  {b.title}
                </h3>
                <p className="text-[#8f8f8f] mt-2 max-w-xl">{b.subtitle}</p>
              </div>

              <div className="md:col-span-2 flex md:justify-end">
                <span className="inline-flex items-center gap-1.5 font-mono text-xs uppercase tracking-[0.18em] text-[#a3a3a3] group-hover:text-[#FAFAFA] transition-colors">
                  Read
                  <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </span>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
